<template>
  <div>
    <router-link to="/">Home</router-link>
    <h4>Город United City</h4>
    Да, город =) Моя детская мечта. Мечта, конечно, была обусловлена десткими желаниями безопасности и идеальности.
    Сейчас не так, United City - это цель. Я выбрал её, чтобы кайфовать и рализовать свой потенциал.
    <ul>
      <li>Я не строю город один, и я не руководитель строительства.</li>
      <li>Сейчас не ведётся никаких строительных работ, но процесс уже идёт.</li>
      <li>10 минут сегодня, пара диалогов завтра и через несколько лет, я уверен, вырастет деревня, а потом город.</li>
    </ul>
    Зачем строить ещё один город, если их достаточно?
    <ul>
      <li>Просто потому что каждый хочет свой аккаунт в сети, своих друзей и свой дом. Я хочу свой город и я такой не один.</li>
      <li>Я нахожу это очень интересным делом. Это огромное поле для экспериментов и изобретений!</li>
      <li>Эта цель объединяет, сплочает людей. Она выходит за пределы жизни одного человека.
        В какой-то момент человек чувствует желание стать частью чего-то большоего и значимого.</li>
    </ul>
    Так что конкретно мы делаем сейчас?
    <ul>
      <li>Формулируем ценности</li>
      <li>Собираем сообщество</li>
      <li>Аланизируем и планируем</li>
    </ul>
    Если тебе интересно, напиши мне.
  </div>
</template>

<script>
export default {
name: "WannaAudit"
}
</script>

<style scoped>

</style>
